var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDuplicate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.00009V12H17.3C17.6866 12 18 12.3134 18 12.7V19.0001L23 19V9L15 9.00009ZM18 20.0001L23.3 20C23.6866 20 24 19.6866 24 19.3V8.7C24 8.3134 23.6866 8 23.3 8L14.7 8.0001C14.3134 8.0001 14 8.3135 14 8.7001V12L8.70001 11.9999C8.31341 11.9999 8 12.3133 8 12.6999V23.2999C8 23.6865 8.3134 23.9999 8.69999 23.9999L17.3 24C17.6866 24 18 23.6866 18 23.3V20.0001ZM9 12.9999V22.9999L17 23V13L9 12.9999Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDuplicate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Duplicate.848f956da1ec9f1292373bb7055ef1d4.svg";